import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GeneralSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionsPage"] */ "/app/src/modules/promotions/components/PromotionsPage/index.tsx");
